import { render, staticRenderFns } from "./DashboardAction.vue?vue&type=template&id=c763dcbe&scoped=true"
import script from "./DashboardAction.vue?vue&type=script&lang=js"
export * from "./DashboardAction.vue?vue&type=script&lang=js"
import style0 from "./DashboardAction.vue?vue&type=style&index=0&id=c763dcbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c763dcbe",
  null
  
)

export default component.exports